<template>
    <v-container
        class="pt-0"
    >
        <v-row
            justify="center"
        >
            <v-col
                class="pt-0"
                xs="12"
                sm="12"
                md="12"
                lg="10"
                xl="10"
            >
        <!---------------------------------------->
        <!--           Search Filters           -->
        <!---------------------------------------->
                <v-row
                    no-gutters
                >
                    <v-col
                        class="pl-5 pr-3 mb-2"
                    >
                        <v-text-field
                            v-model="keywords"
                            label="Keywords"
                            hide-details
                            prepend-inner-icon="search"
                            height="35"
                            clearable
                        ></v-text-field>
                    </v-col>
                    <v-col
                        class="shrink mr-3"
                    >
            <!--------------------------------------->
            <!--  Initialize Add Ingerdient Dialog -->
            <!--------------------------------------->
                        <v-dialog
                            v-model="createNewIngredientDialog"
                            persistent
                            width="500"
                            style="overflow-x: hidden"
                        >
                            <template
                                v-slot:activator="{ on: dialog, attrs}"
                            >
                                <v-col
                                    class="px-3"
                                    cols="12"
                                    xl="3"
                                    lg="4"
                                    md="4"
                                    sm="4"
                                    xs="12"
                                >
                                    <v-tooltip
                                        top
                                    >
                                        <template v-slot:activator="{ on: tooltip}">
                                            <v-btn
                                                fab
                                                small
                                                v-bind="attrs"
                                                v-on="{ ...tooltip, ...dialog}"
                                                color="#74cf74"
                                            >
                                                <v-icon
                                                    color="#ffffff"
                                                    medium
                                                >
                                                    post_add
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>
                                            Add Ingredient
                                        </span>
                                    </v-tooltip>
                                </v-col>
                            </template>
                <!--------------------------------------->
                <!-- Ingredient Pop-up Dialog Contents -->
                <!--------------------------------------->
                            <v-card>
                                <AddIngredient/>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>

        <!------------------------------------------------------------------------------------>
        <!--                                 Search Results                                 -->
        <!------------------------------------------------------------------------------------>
                <v-row
                    no-gutters
                >
            <!--------------------------------------->
            
            <!--------------------------------------->
                    <v-dialog
                        :key="rerender"
                        v-model="editIngredientDialog"
                        persistent
                        width="500"
                        style="overflow-x: hidden"
                    >
                        <template
                            v-slot:activator="{ on }"
                        >
                            <v-row
                                no-gutters
                                class="mt-5"
                            >
                                <v-col
                                    cols="12"
                                    class="px-5"
                                >
                                    <v-data-table
                                        :headers="[
                                            {
                                            text: 'Name',
                                            align: 'start',
                                            sortable: true,
                                            value: 'name',
                                            },
                                            { text: 'Units', value: 'measurement_unit' },
                                            { text: 'Audited', value: 'auditedDate' },
                                            { text: 'Usage', value: 'usage' },
                                        ]"
                                        :items="filteredIngredients"
                                        :items-per-page="30"
                                        :footer-props="{'items-per-page-options':[15,30,50,-1]}"
                                        class="elevation-2"
                                        dense
                                        @click:row="rowClicked"
                                        v-on="on"
                                    ></v-data-table>
                                </v-col>
                            </v-row>
                        </template>
            <!--------------------------------------->
            <!-- Ingredient Pop-up Dialog Contents -->
            <!--------------------------------------->
                        <v-card
                            style="overflow-x: hidden"
                        >
                            <v-row
                                no-gutters
                            >
                                <v-col>
                                    <EditIngredient/>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-dialog>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
let moment = require('moment');
import AddIngredient from '@/components/menu/AddIngredient.vue'
import EditIngredient from '@/components/menu/EditIngredient.vue'
import _ from 'lodash';

export default {
    mounted() {
        this.filteredIngredients = this.ingredients;
    },

    components: {
        AddIngredient,
        EditIngredient
    },

    data: () => ({
        moment: moment,
        keywords: null,
        filteredIngredients: [],
    }),

    watch: {
        keywords() {
            this.debouncedApplyFilters();
        },
    },


    methods: {
        debouncedApplyFilters:_.debounce(function() {
            this.applyFilters();
            },400
        ),
        applyFilters() {
            this.updateFilters();
            this.forceRerender();
        },
        updateFilters() {
            let result = [];
            let include = 0;
            let includedKeywordsLength = 0;
            let keywordsArray = [];
            let keywordsLength = 0;
            let ingredientsLength = this.ingredients.length;

            if (this.keywords == null || this.keywords == '') {
                keywordsLength = 0;
            } else {
                for (let k = 0; k < this.keywords.split(" ").length; k++) {
                    keywordsArray.push(this.keywords.split(" ")[k]);
                }
                keywordsLength = keywordsArray.length;
            }

            for (let i=0; i < ingredientsLength; i++){
                //reset include to 0, only add ingredient to result if include passes all filters
                include = 0;
                includedKeywordsLength = 0;

                //-----        filter for keywords        -----//
                if (keywordsLength == 0) {
                    include += 1;
                } else {
                    for (let k=0; k < keywordsLength; k++) {
                        if (this.ingredients[i].name.toLowerCase().includes(keywordsArray[k].toLowerCase())) {
                            includedKeywordsLength += 1;
                        }
                    }
                    if (includedKeywordsLength >= keywordsLength){
                        include += 1
                    }
                }

                if (include == 1) {
                    result.push(this.ingredients[i])
                }
            }

            //--------------------------------------------//
            //               return results               //
            //--------------------------------------------//
            this.filteredIngredients = result;
        },
        forceRerender() {
            this.rerender += 1;

        },
        rowClicked(value) {
            this.selectedIngredientID = value.id;
            this.editIngredientDialog = true;
        }

    },

    computed: {
        adminView() {
            return this.$store.getters['data/adminView'];
        },
        ingredients() {
            let result =  this.$store.getters['data/ingredient'];

            let ingredientsLength = result.length;

            for (let i=0; i < ingredientsLength; i++){
                if (result[i].audited == null){
                    result[i].auditedDate = null;
                } else {
                    result[i].auditedDate = moment(result[i].audited).format('M/D/YYYY')
                }
            }

            return result;
        },
        selectedIngredientID: {
            get(){
                return this.$store.getters['data/selectedIngredientId'];
            },
            set(value) {
                this.$store.dispatch('data/updateSelectedIngredientId',value);
            }
        },
        createNewIngredientDialog: {
            get(){
                return this.$store.getters['data/createNewIngredientDialog'];
            },
            set(value) {
                this.$store.dispatch('data/updateCreateNewIngredientDialog',value);
            }
        },
        editIngredientDialog: {
            get(){
                return this.$store.getters['data/editIngredientDialog'];
            },
            set(value) {
                this.$store.dispatch('data/updateEditIngredientDialog',value);
            }
        },
        rerender: {
            get(){
                return this.$store.getters['data/rerender'];
            },
            set(value) {
                this.$store.dispatch('data/forceRerender',value);
            }
        },
        processing: {
            get() {
                return this.$store.getters['data/processing'];
            },
            set(value) {
                this.$store.dispatch('data/updateProcessing',value);
            }
        },
        editIngredient: {
            get(){
                return this.$store.getters['data/editIngredient'];
            },
            set(value) {
                this.$store.dispatch('data/updateEditIngredient',value);
            }
        }

    }
};
</script>
